import React, { memo } from 'react';
import { QuestionIcon } from '@modules/performance/components/question-icon/question-icon';
import BlocksBar from '@modules/performance/components/block-bar/block-bar';
import { PerformanceQuestionType } from '@modules/performance/definitions';
import { useTranslation } from 'react-i18next';

interface CompetencyHeaderProps {
  totalBlocks: number;
  averageFilled: number;
  color: string;
}

const CompetencyHeader = memo<CompetencyHeaderProps>(({
  totalBlocks,
  averageFilled,
  color,
}) => {
  const { t } = useTranslation();

  return (
    <div className="tw-flex tw-flex-row tw-items-center tw-gap-3">
      <QuestionIcon
        type={PerformanceQuestionType.COMPETENCIES}
        className="!tw-w-4 !tw-h-4"
      />
      <div className="tw-text-gray-textDark tw-text-xl tw-font-semibold">
        {t('performance:competencies')}
      </div>
      <div className="tw-w-[1px] tw-h-4 tw-flex tw-flex-col tw-bg-gray-border" />
      <BlocksBar
        total={totalBlocks}
        filled={averageFilled}
        color={color}
      />
    </div>
  );
});

CompetencyHeader.displayName = 'CompetencyHeader';

export default CompetencyHeader;
